var _rect, _path, _path2, _path3, _circle, _path4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGenerator(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 226,
    height: 216,
    viewBox: "0 0 226 216",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 216,
    height: 164,
    rx: 16,
    stroke: "black",
    strokeWidth: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 206V168H53L35 206H16Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5 148.5H116H194.398C196.647 148.5 198.453 146.647 198.397 144.4L195.598 32.8996C195.543 30.7303 193.769 29 191.599 29H35.5C33.2909 29 31.5 30.7909 31.5 33V144.5C31.5 146.709 33.2909 148.5 35.5 148.5Z",
    stroke: "black",
    strokeWidth: 8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M222 168C222 192.301 202.301 212 178 212C153.699 212 134 192.301 134 168C134 143.699 153.699 124 178 124C202.301 124 222 143.699 222 168Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 8
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 112,
    cy: 89,
    r: 42,
    stroke: "black",
    strokeWidth: 8
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M95.7816 87.2767L113.081 65.6411C114.348 64.0567 116.897 65.1473 116.625 67.1577L115.122 78.2937C114.954 79.5328 115.952 80.6198 117.201 80.559L126.259 80.1178C127.984 80.0338 128.998 82.0297 127.911 83.3731L110.186 105.292C108.853 106.94 106.209 105.656 106.681 103.59L109.221 92.4572C109.517 91.1631 108.493 89.9456 107.167 90.0149L97.4481 90.523C95.7246 90.613 94.7039 88.6245 95.7816 87.2767Z",
    fill: "url(#paint0_linear_111_14)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_111_14",
    x1: 115.275,
    y1: 64.2903,
    x2: 92.1605,
    y2: 75.8506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E84126"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5ED4C"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenerator);
export default __webpack_public_path__ + "static/media/generator.15d8c326e53c1a8657d6a7a6c0a5da2b.svg";
export { ForwardRef as ReactComponent };